import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify";

// components
import FormBanner from "../components/ContactUs/FormBanner";

// seo
import Seo from "../components/Seo";

// services
import { sendToLSQ } from "../services/LeadSquared";
import { Mixpanel, MixpanelEvents } from "../services/Mixpanel";

// custom hooks
import { useCommonPageTracking } from "../hooks/usePageTracking";

// css
import * as styles from "../components/ContactUs/ContactUs.module.css";

const ContactPage = props => {
  const [loading, setLoading] = useState(false);

  // Use common page tracking hooks
  const { deviceType, operatingSystem } = useCommonPageTracking(
    "Contact Us Page",
    props.location.search
  );

  // Define form fields
  const formFields = [
    {
      name: "fullName",
      placeholder: "Full Name*",
      label: "Please enter your name",
      type: "text",
      colSize: 6,
      validation: {
        required: "Please enter your full name",
        pattern: {
          value: /^[A-Za-z\s]+$/, // eslint-disable-line no-useless-escape
          message: "Please enter a valid name",
        },
        maxLength: {
          value: 50,
          message: "Name is too long",
        },
      },
    },
    {
      name: "mobileNumber",
      placeholder: "Mobile Number*",
      label: "Please enter your mobile number",
      type: "text",
      inputMode: "numeric",
      maxLength: 10,
      colSize: 6,
      validation: {
        required: "Please enter your mobile number",
        pattern: {
          value: /^\+?([1-9]{1})\)?[-. ]?([0-9]{5})[-. ]?([0-9]{4})$/, // eslint-disable-line no-useless-escape
          message: "Please enter a valid mobile number",
        },
        maxLength: {
          value: 10,
          message: "Invalid mobile number",
        },
      },
    },
  ];

  // Handle form submission
  const handleFormSubmit = async data => {
    setLoading(true);

    // Mixpanel tracking
    Mixpanel.track(MixpanelEvents.contact_form_completed, {
      page_name: "Contact Us Page",
      asset: "India Website",
      asset_name: "India Corporate Website",
      user_name: data.fullName,
      user_phone: data.mobileNumber,
      device_type: deviceType,
      operating_system: operatingSystem,
    });

    // LeadSquared params
    const leadSquaredParams = {
      FirstName: data.fullName,
      Phone: data.mobileNumber,
      mx_Website_CTA: "Contact Us Page Form",
      mx_Latest_Source: "New Website",
      mx_Device_Mobile_Desktop: deviceType,
      mx_msc_Operating_System: operatingSystem,
    };

    try {
      await sendToLSQ(leadSquaredParams);
      toast.success("Thank you for your inquiry! We will contact you soon.", {
        toastId: "contactUsToast",
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        draggable: false,
      });
    } catch (error) {
      console.error("LSQ error:", error);
      toast.error("Something went wrong. Please try again.", {
        toastId: "contactUsToast",
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        draggable: false,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Seo
        title="Contact Twin Health India | Get in Touch Today"
        description="Have a question or ready to begin your metabolic health journey? Get in touch with the Twin Health India team and take your first step today."
      />

      <FormBanner
        formFields={formFields}
        handleFormSubmit={handleFormSubmit}
        loading={loading}
        ctaText="Submit"
        mixpanelPageName="Contact Page"
        formIsModal={false}
        showCheckbox={true}
        checkboxText="I agree to be contacted by Twin Health via Call, SMS, RCS, WhatsApp & Email"
        checkboxColor="#AD2576"
        buttonStyles={{ width: "250px" }}
      />

      <ToastContainer
        containerId="contactUsToast"
        position="top-center"
        autoClose={5000}
        hideProgressBar={true}
        closeOnClick={true}
        draggable={false}
        toastClassName={styles.toastClassName}
      />
    </>
  );
};

export default ContactPage;
